import React from 'react';

import { SearchForm } from '../../helpers/uiComponents/Search';

class MonitorSearch extends React.Component {
    render() {
        return(
            <div id="monitor-search">
                <SearchForm page="uptime" />
            </div>
        )
    }
}
export default MonitorSearch;


// WEBPACK FOOTER //
// ./src/component_uptime/components/MonitorSearch.js